
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import $ from 'jquery';
import initializers from '../../dependencies/initializers';
import candidatesupport1 from '../../images/candidatesupport1.png';
import appRateIOS from '../../images/rateAppApple.png';
import appRateAndroid from '../../images/rateAppGoogle.png';
import appRateIOSMobile from '../../images/rateAppAppleMobile.png';
import appRateAndroidMobile from '../../images/rateAppGoogleMobile.png';
import weGotYourBack from '../../images/wegotyourback.png';
import quoteBlueIcon from '../../images/quote-blue.svg';
import iconFiveStar from '../../images/5-star.svg';
import FooterNew from '../partials/FooterNew';
import HeaderNewClear from '../partials/HeaderNewClear';
import bindAll from 'lodash/bindAll';
import { translate } from '../../helpers/global';
import ReactHtmlParser from 'react-html-parser';


const detailCard1 = [
  {
    testimoni:`HOME_PAGE_CUSTOMERS_SAY_2`,
    user:'Heidi Smith'
  },
  {
    testimoni:`HOME_PAGE_CUSTOMERS_SAY_3`,
    user:'Franklin Mal'
  },
  {
    testimoni:`HOME_PAGE_CUSTOMERS_SAY_4`,
    user:'Solihatin Azizah'
  }

]

const detailCard2 = [
  {
    testimoni:`HOME_PAGE_CUSTOMERS_SAY_5`,
    user:'Fahmi Hasya'
  },
  {
    testimoni:`HOME_PAGE_CUSTOMERS_SAY_1`,
    user:'Otniel Susanto Gunawan'
  },
  {
    testimoni:`HOME_PAGE_CUSTOMERS_SAY_6`,
    user:'Eri Montinger'
  }

]

const detailCard1Mobile = [
  {
    testimoni:`HOME_PAGE_CUSTOMERS_SAY_2`,
    user:'Heidi Smith'
  }
]

const detailCard2Mobile = [
  {
    testimoni:`HOME_PAGE_CUSTOMERS_SAY_3`,
    user:'Franklin Mal'
  }
]

let dataCard = [

]

dataCard.push(detailCard1);
dataCard.push(detailCard2);

let dataCardMobile = [

]

dataCardMobile.push(detailCard1Mobile);
dataCardMobile.push(detailCard2Mobile);

class CandidateSupport extends React.Component<Props>
{
  constructor(props)
  {
    super(props)

    this.state={
      sliderStateIndex:0,
    }

    bindAll(this, [
      'renderSlider',
      'moveSlide',
      'renderButtonDot',
      'renderContentSlider',
		])
  }

  renderContentSlider(obj, injectedClass){
    const{globalGetLanguages}=this.props
    let element = []
    console.log(obj)
    obj.map((val,index)=>{

      element.push(
        <div className={injectedClass}>
          <img src={quoteBlueIcon} />
          <p>
          {translate(globalGetLanguages,val.testimoni)}
          </p>
          <label>
            {val.user} <img src={iconFiveStar} />
          </label>
        </div>
      )
      
    })
  
    console.log(obj)
    return element
  }

  moveSlide(e,params,quote=null){
    const{sliderStateIndex} = this.state
   
      if (params) {
        this.setState({sliderStateIndex:sliderStateIndex+1})
      }else{
        this.setState({sliderStateIndex:sliderStateIndex-1})
      }

   
  }

  renderButtonDot(quote=null){
    const{sliderStateIndex} = this.state
    let buttonSlider = []
   
      dataCard.map((obj,index)=>{
        if (sliderStateIndex == index) {
          buttonSlider.push(
          <button ></button> 
  
            )
        }else{
          buttonSlider.push(
            <button
            onClick={()=>{
              this.setState({sliderStateIndex:index})
            }}
             className="disabled"></button>
            )
        }
       
      })
    
    

    return buttonSlider
  }

  renderButtonDotMobile(quote=null){
    const{sliderStateIndex} = this.state
    let buttonSlider = []
   
      dataCardMobile.map((obj,index)=>{
        if (sliderStateIndex == index) {
          buttonSlider.push(
          <button ></button> 
  
            )
        }else{
          buttonSlider.push(
            <button
            onClick={()=>{
              this.setState({sliderStateIndex:index})
            }}
             className="disabled"></button>
            )
        }
       
      })
    
    

    return buttonSlider
  }

  renderSlider(){
    const{sliderStateIndex} = this.state
    let element = []

    dataCard.map((obj,index)=>{
      console.log(index)
      let injectedClass = sliderStateIndex === index  ? "slider-item active-anim" : "slider-item absolute "
      element.push(
        <div className={`review-text-app horizontal-item--between flex-row ${sliderStateIndex === index ? 'active-anim': 'absolute'} `}>
          {this.renderContentSlider(obj, injectedClass)}
        </div>
      );
    })
    

    return element
  }

  renderSliderMobile(){
   
    const{sliderStateIndex} = this.state
    let element = []

    dataCardMobile.map((obj,index)=>{
      console.log(index)
      let injectedClass = sliderStateIndex === index  ? "slider-item active-anim" : "slider-item absolute "
      element.push(
        <div className={`review-text-app horizontal-item--between flex-row ${sliderStateIndex === index ? 'active-anim': 'absolute'} `}>
          {this.renderContentSlider(obj, injectedClass)}
        </div>
      );
    })
    

    return element
  }

  componentDidMount()
  {
    window.scrollTo(0,0)
    $('ul.price-faq li a.dropdown-new').click(function(event){
        event.preventDefault();
        
        if(!$(this).hasClass('is-on')){
            $(this).addClass('is-on').parent().find('div').slideDown('fast');
        }else{
            $(this).removeClass('is-on').parent().find('div').slideUp('fast');
        }
    });
    $('ul.support-faq li a.dropdown-new').click(function(event){
        event.preventDefault();
        
        if(!$(this).hasClass('is-on')){
            $(this).addClass('is-on').parent().find('div').slideDown('fast');
        }else{
            $(this).removeClass('is-on').parent().find('div').slideUp('fast');
        }
    });
    $('ul.flow-faq li a.dropdown-new').click(function(event){
        event.preventDefault();
        
        if(!$(this).hasClass('is-on')){
            $(this).addClass('is-on').parent().find('div').slideDown('fast');
        }else{
            $(this).removeClass('is-on').parent().find('div').slideUp('fast');
        }
    });
  }

  render()

  {
    const{globalGetLanguages}=this.props
    const { sliderStateIndex } =this.state
    const currentSize = dataCard.length

    const content1 = 
    (
      <section className="sec-con januar-div1">
        <div className='januar-div2 vertical-item--center'>
          <div>
            <label>{translate(globalGetLanguages,'CANDIDATE_SUPPORT_CARD_1_TITLE')}</label>
            <p>
              {translate(globalGetLanguages,'CANDIDATE_SUPPORT_CARD_1_TEXT')}
            </p>
          </div>
        </div>
        <div className='januar-div2 right'>
          <img src={candidatesupport1} />
        </div>
      </section>
    )

    const content2 = 
    (
      <div className="sec-white">
        <section className="experience-review">
          <div>
            <label>{translate(globalGetLanguages,'CANDIDATE_SUPPORT_CARD_2_TITLE')}</label>
            <span>{translate(globalGetLanguages,'CANDIDATE_SUPPORT_CARD_2_TEXT')}</span>
          </div>
          <div className="desktop-hide">
            <div className="horizontal-item--center rate">
              <a className="a-transparent" href="https://apps.apple.com/id/app/astronaut-q-a/id1098124247" target="_blank" rel="noopener noreferrer"><img src={appRateIOS} /></a>
              <a className="a-transparent" href="https://play.google.com/store/apps/details?id=co.astrnt.androidqa" target="_blank" rel="noopener noreferrer"><img src={appRateAndroid} /></a>
            </div>
          </div>
          <div className="mobile-hide">
            <div className="horizontal-item--around rate">
              <a className="a-transparent" href="https://apps.apple.com/id/app/astronaut-q-a/id1098124247" target="_blank" rel="noopener noreferrer"><img src={appRateIOSMobile} /></a>
              <a className="a-transparent" href="https://play.google.com/store/apps/details?id=co.astrnt.androidqa" target="_blank" rel="noopener noreferrer"><img src={appRateAndroidMobile} /></a>
            </div>
          </div>
          <div className="arrow-slider flex-container flex-end">
            <div><button
            onClick={(e)=>{this.moveSlide(e,false)}} 
            className={`${sliderStateIndex == 0? 'disabled':''}`}
            disabled={sliderStateIndex == 0? true:false}
            ><i className="fas fa-arrow-left"></i></button></div>
            <div><button
            onClick={(e)=>{this.moveSlide(e,true)}}
            className={`${sliderStateIndex == (currentSize-1)? 'disabled':''}`}
            disabled={sliderStateIndex == (currentSize-1)? true:false}
            ><i className="fas fa-arrow-right"></i></button></div>
          </div>
         
          <Fragment>
            <div className="desktop-hide">{this.renderSlider()}</div>
            <div className="mobile-hide">{this.renderSliderMobile()}</div>
          </Fragment>
      
          <div className="horizontal-item--center">
            <div className="bottom-dots">

               <div className="desktop-hide">{this.renderButtonDot()}</div>
               <div className="mobile-hide">{this.renderButtonDotMobile()}</div>
            </div>
          </div>
          <div className="button-read-review">
            <a href="https://apps.apple.com/id/app/astronaut-q-a/id1098124247" target="_blank" rel="noopener noreferrer">{translate(globalGetLanguages,'CANDIDATE_SUPPORT_CARD_REVIEW_APPLE')}</a>
            <a href="https://play.google.com/store/apps/details?id=co.astrnt.androidqa" target="_blank" rel="noopener noreferrer">{translate(globalGetLanguages,'CANDIDATE_SUPPORT_CARD_REVIEW_GOOGLE')}</a>
          </div>
        </section>
      </div>
    )

    const contentent6prepare = 
    (
      <div style={{display: 'none'}}>
        <ul>
          <li>
            <i className="far fa-thumbs-up"></i>
            {translate(globalGetLanguages,'CANDIDATE_SUPPORT_CARD_3_CONTENT_1_LABEL_1')}
            <span>
            {translate(globalGetLanguages,'CANDIDATE_SUPPORT_CARD_3_CONTENT_1_TEXT_1')}
            </span>
          </li>
          <li>
          {translate(globalGetLanguages,'CANDIDATE_SUPPORT_CARD_3_CONTENT_1_LABEL_2')}
            <span>
            {translate(globalGetLanguages,'CANDIDATE_SUPPORT_CARD_3_CONTENT_1_TEXT_2')}
            </span>
          </li>
          <li>
          {translate(globalGetLanguages,'CANDIDATE_SUPPORT_CARD_3_CONTENT_1_LABEL_3')}
            <span>
            {translate(globalGetLanguages,'CANDIDATE_SUPPORT_CARD_3_CONTENT_1_TEXT_3')}
             </span>
          </li>
          <li>
          {translate(globalGetLanguages,'CANDIDATE_SUPPORT_CARD_3_CONTENT_1_LABEL_4')}
            <span>
            {translate(globalGetLanguages,'CANDIDATE_SUPPORT_CARD_3_CONTENT_1_TEXT_4')}
             </span>
          </li>
          <li>
          {translate(globalGetLanguages,'CANDIDATE_SUPPORT_CARD_3_CONTENT_1_LABEL_5')}
            <span>
            {translate(globalGetLanguages,'CANDIDATE_SUPPORT_CARD_3_CONTENT_1_TEXT_5')}
              </span>
          </li>
          <li>
          {translate(globalGetLanguages,'CANDIDATE_SUPPORT_CARD_3_CONTENT_1_LABEL_6')}
            <span>
            {translate(globalGetLanguages,'CANDIDATE_SUPPORT_CARD_3_CONTENT_1_TEXT_6')}
             </span>
          </li>
        </ul>
      </div>
    )

    const content3testQna = 
    (
      <div style={{display: 'none'}}>
        <ul>
          <li>
            <span className="mobile-text-force">{translate(globalGetLanguages,'CANDIDATE_SUPPORT_CARD_3_CONTENT_2_TEXT')}</span>
            <a className="button-test" href={`${initializers.recruiter_host}/test`} target="_blank" rel="noopener noreferrer">{translate(globalGetLanguages,'CANDIDATE_SUPPORT_CARD_3_CONTENT_2_TEST_QNA')}</a>
          </li>
        </ul>
      </div>
    )

    const content3express =
    (
      <div style={{display: 'none'}}>
        <ul>
          <li>
            <span>
            {translate(globalGetLanguages,'CANDIDATE_SUPPORT_CARD_3_CONTENT_3_INTRO_TEXT')}
              </span>
          </li>
          <li>
          {translate(globalGetLanguages,'CANDIDATE_SUPPORT_CARD_3_CONTENT_3_LABEL_1')}
            <span>
            {translate(globalGetLanguages,'CANDIDATE_SUPPORT_CARD_3_CONTENT_3_TEXT_1')}
               </span>
          </li>
          <li>
          {translate(globalGetLanguages,'CANDIDATE_SUPPORT_CARD_3_CONTENT_3_LABEL_2')}
            <span>
            {translate(globalGetLanguages,'CANDIDATE_SUPPORT_CARD_3_CONTENT_3_TEXT_2')}
                </span>
          </li>
          <li>
          {translate(globalGetLanguages,'CANDIDATE_SUPPORT_CARD_3_CONTENT_3_LABEL_3')}
            <span>
            {translate(globalGetLanguages,'CANDIDATE_SUPPORT_CARD_3_CONTENT_3_TEXT_3')}
              </span>
          </li>
        </ul>
      </div>
    )

    const content3 =
    (
      <div id='pricing'>
        <section className='sec-con flow-container'>
          <label>{translate(globalGetLanguages,'CANDIDATE_SUPPORT_CARD_3_TITLE')}</label>
          <p>{translate(globalGetLanguages,'CANDIDATE_SUPPORT_CARD_3_TEXT')}</p>
          <ul>
            <li>
              <ul className='on-right'>
                <li>
                  <ul className='flow-faq'>
                    <li>
                      <a href="#" className='dropdown-new'>
                      {translate(globalGetLanguages,'CANDIDATE_SUPPORT_CARD_3_CONTENT_1_TITLE')}
                        <i className='fa fa-chevron-down'></i>
                      </a>
                      { contentent6prepare }
                    </li>
                    <li>
                      <a href="#" className='dropdown-new'>
                      {translate(globalGetLanguages,'CANDIDATE_SUPPORT_CARD_3_CONTENT_2_TITLE')}
                        <i className='fa fa-chevron-down'></i>
                      </a>
                      { content3testQna }
                    </li>
                    <li>
                      <a href="#" className='dropdown-new'>
                      {translate(globalGetLanguages,'CANDIDATE_SUPPORT_CARD_3_CONTENT_3_TITLE')}
                        <i className='fa fa-chevron-down'></i>
                      </a>
                      { content3express }
                    </li>
                  </ul>
                </li>
                <li className="desktop-hide"><img src={weGotYourBack} alt="" /></li>
              </ul>
            </li>
          </ul>
        </section>
      </div>
    )

    const content4 = (
      <div id='pricing' className='sec-white'>
        <section>
          <div className="tit-faq">{translate(globalGetLanguages,'CANDIDATE_SUPPORT_CARD_4_TITLE')}</div>
          <ul className="support-faq">
            <li>
              <a className="dropdown-new" href="#">
                {translate(globalGetLanguages,'CANDIDATE_SUPPORT_FAQ_1')}
                <i className="fa fa-angle-down" />
              </a>
              <div style={{display: 'none'}}>
                <ul>
                  <li>
                    {translate(globalGetLanguages,'CANDIDATE_SUPPORT_FAQ_1_TEXT')}
                  </li>
                </ul>
              </div>
            </li>
            <li>
              <a className="dropdown-new" href="#">
                {translate(globalGetLanguages,'CANDIDATE_SUPPORT_FAQ_2')}
                <i className="fa fa-angle-down" />
              </a>
              <div style={{display: 'none'}}>
                <ul>
                  {ReactHtmlParser(translate(globalGetLanguages,'CANDIDATE_SUPPORT_FAQ_2_TEXT'))}
                </ul>
              </div>
            </li>
            <li>
              <a className="dropdown-new" href="#">
                {translate(globalGetLanguages,'CANDIDATE_SUPPORT_FAQ_3')}
                <i className="fa fa-angle-down" />
              </a>
              <div style={{display: 'none'}}>
                <ul>
                  {ReactHtmlParser(translate(globalGetLanguages,'CANDIDATE_SUPPORT_FAQ_3_TEXT'))}
                </ul>
              </div>
            </li>
            <li>
              <a className="dropdown-new" href="#">
                {translate(globalGetLanguages,'CANDIDATE_SUPPORT_FAQ_4')}
                <i className="fa fa-angle-down" />
              </a>
              <div style={{display: 'none'}}>
                <ul>
                  {ReactHtmlParser(translate(globalGetLanguages,'CANDIDATE_SUPPORT_FAQ_4_TEXT'))}
                </ul>
              </div>
            </li>
            <li>
              <a className="dropdown-new" href="#">
                {translate(globalGetLanguages,'CANDIDATE_SUPPORT_FAQ_5')}
                <i className="fa fa-angle-down" />
              </a>
              <div style={{display: 'none'}}>
                <ul>
                  {ReactHtmlParser(translate(globalGetLanguages,'CANDIDATE_SUPPORT_FAQ_5_TEXT'))}
                </ul>
              </div>
            </li>
            <li>
              <a className="dropdown-new" href="#">
                {translate(globalGetLanguages,'CANDIDATE_SUPPORT_FAQ_6')}
                <i className="fa fa-angle-down" />
              </a>
              <div style={{display: 'none'}}>
                <ul>
                  {ReactHtmlParser(translate(globalGetLanguages,'CANDIDATE_SUPPORT_FAQ_6_TEXT'))}
                </ul>
              </div>
            </li>
            <li>
              <a className="dropdown-new" href="#">
                {translate(globalGetLanguages,'CANDIDATE_SUPPORT_FAQ_7')}
                <i className="fa fa-angle-down" />
              </a>
              <div style={{display: 'none'}}>
                <ul>
                  {ReactHtmlParser(translate(globalGetLanguages,'CANDIDATE_SUPPORT_FAQ_7_TEXT'))}
                </ul>
              </div>
            </li>
            <li>
              <a className="dropdown-new" href="#">
                {translate(globalGetLanguages,'CANDIDATE_SUPPORT_FAQ_8')}
                <i className="fa fa-angle-down" />
              </a>
              <div style={{display: 'none'}}>
                <ul>
                  {ReactHtmlParser(translate(globalGetLanguages,'CANDIDATE_SUPPORT_FAQ_8_TEXT'))}
                </ul>
              </div>
            </li>
            <li>
              <a className="dropdown-new" href="#">
                {translate(globalGetLanguages,'CANDIDATE_SUPPORT_FAQ_9')}
                <i className="fa fa-angle-down" />
              </a>
              <div style={{display: 'none'}}>
                <ul>
                  {ReactHtmlParser(translate(globalGetLanguages,'CANDIDATE_SUPPORT_FAQ_9_TEXT'))}
                </ul>
              </div>
            </li>
            <li>
              <a className="dropdown-new" href="#">
                {translate(globalGetLanguages,'CANDIDATE_SUPPORT_FAQ_10')}
                <i className="fa fa-angle-down" />
              </a>
              <div style={{display: 'none'}}>
                <ul>
                  {ReactHtmlParser(translate(globalGetLanguages,'CANDIDATE_SUPPORT_FAQ_10_TEXT'))}
                </ul>
              </div>
            </li>
            <li>
              <a className="dropdown-new" href="#">
                {translate(globalGetLanguages,'CANDIDATE_SUPPORT_FAQ_11')}
                <i className="fa fa-angle-down" />
              </a>
              <div style={{display: 'none'}}>
                <ul>
                  {ReactHtmlParser(translate(globalGetLanguages,'CANDIDATE_SUPPORT_FAQ_11_TEXT'))}
                </ul>
              </div>
            </li>
            <li>
              <a className="dropdown-new" href="#">
                {translate(globalGetLanguages,'CANDIDATE_SUPPORT_FAQ_12')}
                <i className="fa fa-angle-down" />
              </a>
              <div style={{display: 'none'}}>
                <ul>
                  {ReactHtmlParser(translate(globalGetLanguages,'CANDIDATE_SUPPORT_FAQ_12_TEXT'))}
                </ul>
              </div>
            </li>
            <li>
              <a className="dropdown-new" href="#">
                {translate(globalGetLanguages,'CANDIDATE_SUPPORT_FAQ_13')}
                <i className="fa fa-angle-down" />
              </a>
              <div style={{display: 'none'}}>
                <ul>
                  {ReactHtmlParser(translate(globalGetLanguages,'CANDIDATE_SUPPORT_FAQ_13_TEXT'))}
                </ul>
              </div>
            </li>
            <li>
              <a className="dropdown-new" href="#">
                {translate(globalGetLanguages,'CANDIDATE_SUPPORT_FAQ_14')}
                <i className="fa fa-angle-down" />
              </a>
              <div style={{display: 'none'}}>
                <ul>
                  {ReactHtmlParser(translate(globalGetLanguages,'CANDIDATE_SUPPORT_FAQ_14_TEXT'))}
                </ul>
              </div>
            </li>
            <li>
              <a className="dropdown-new" href="#">
                {translate(globalGetLanguages,'CANDIDATE_SUPPORT_FAQ_15')}
                <i className="fa fa-angle-down" />
              </a>
              <div style={{display: 'none'}}>
                <ul>
                  {ReactHtmlParser(translate(globalGetLanguages,'CANDIDATE_SUPPORT_FAQ_15_TEXT'))}
                </ul>
              </div>
            </li>
            <li>
              <a className="dropdown-new" href="#">
                {translate(globalGetLanguages,'CANDIDATE_SUPPORT_FAQ_16')}
                <i className="fa fa-angle-down" />
              </a>
              <div style={{display: 'none'}}>
                <ul>
                  {ReactHtmlParser(translate(globalGetLanguages,'CANDIDATE_SUPPORT_FAQ_16_TEXT'))}
                </ul>
              </div>
            </li>
          </ul>
        </section>
      </div>
    );

    const renderComponent = 
    (
      <div id='homepage' className='support'>
        <HeaderNewClear isOnStatusLogo="is-on" />
        { content1 }
        { content2 }
        { content3 }
        { content4 }
        <FooterNew />
      </div>
    )
    return renderComponent
  }
}

const mapStateToProps = (state) => {
  return{ 
    globalGetLanguages:state.globalGetLanguages,
  }
  
}

export default connect(mapStateToProps, null)(CandidateSupport)